module.exports = __webpack_public_path__ + "img/POWR.4ed0d469.svg";